export default "__VITE_ASSET__C7tvgPp5__"